// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"576":"80e31a42","787":"c88ab05a","962":"49b6098d"}[chunkId] + ".chunk.js";
};